var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNoQuest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 28,
    viewBox: "0 0 7 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50011 21.0998C5.18911 21.0998 6.56112 22.4708 6.56112 24.1608C6.56112 25.8498 5.18911 27.2208 3.50011 27.2208C1.81111 27.2208 0.439114 25.8498 0.439114 24.1608C0.439114 22.4708 1.81111 21.0998 3.50011 21.0998ZM3.48311 17.8888C2.76011 17.8808 2.04011 17.3418 1.75111 16.2718C-0.145886 9.25181 -0.361886 4.64481 0.439114 2.31881C0.605114 1.83681 1.25511 0.776811 3.50011 0.778811C5.74511 0.779811 6.39612 1.84081 6.56112 2.31881C7.36212 4.64481 7.14611 9.25181 5.24911 16.2718C4.95811 17.3498 4.22911 17.8888 3.50011 17.8888H3.48311Z",
    fill: props.fill
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoQuest);
export default __webpack_public_path__ + "static/media/icon_no_quest.95dca3a85c42186a5429afabc260df6c.svg";
export { ForwardRef as ReactComponent };